import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from '@nationwide/internet-servicing-angular-components';
import { PolicyInfoService } from 'app/commercial/claims/services/policy-info.service';
import { environment } from 'environments/environment';
import { commercialConstants } from '../../../../../common/commercial-constants';
import { LoggerService } from '../../../../../shared/services/logger.service';
import { ClaimsDataService } from '../../../services/claims-data.service';
import { CommercialLoggingService } from '../../../services/commercial-logging.service';
@Component({
    selector: 'is-all-updates',
    templateUrl: './all-updates.component.html',
    styleUrls: ['./all-updates.component.scss'],
    standalone: false
})
export class AllUpdatesComponent implements OnInit {
    allEvents: any[] = [];
    breadCrumbs: BreadCrumb[];
    claimEventsFiltered: any[] = [];
    claimInfo: any;
    claimReceivedOrClosed = false;
    currentPage = 'All Updates';
    homeIconLink = environment.NATIONWIDE.accountSummaryPage;
    offset = 0;
    paymentIssued = false;
    serviceFlag = false;

    constructor(
        private LOGGER: LoggerService,
        private router: Router,
        public claimsDataService: ClaimsDataService,
        public policyInfoService: PolicyInfoService,
        private commercialLoggingService: CommercialLoggingService
    ) { }
    getClaimInfo(): void {
        this.claimInfo = this.claimsDataService.getClaimInformation();
        if (this.claimInfo) {
            this.serviceFlag = true;
        }
    }

    getEvents(): void {
        for (const iterator of this.claimsDataService.getClaimEvents()) {
            if (iterator.eventType === 'claimReceived' || iterator.eventType === 'claimClosed' || iterator.eventType === 'paymentIssued') {
                this.claimEventsFiltered.push(iterator);
            }
        }
    }
    navigateToIncidentDetails(): void {
        this.commercialLoggingService.logButtonAction(this.LOGGER, this.currentPage, 'navigate-incident-details', 'success', this.getLogMetadata());
        this.commercialLoggingService.updatePreviousUrlContext();
        this.router.navigate([commercialConstants.URLS.incidentDetails]);
    }
    navigateToPayments(): void {
        this.commercialLoggingService.logButtonAction(this.LOGGER, this.currentPage, 'navigate-payments', 'success', this.getLogMetadata());
        this.commercialLoggingService.updatePreviousUrlContext();
        this.router.navigate([commercialConstants.URLS.payments]);
    }

    ngOnInit(): void {
        this.breadCrumbs = [
            {
                name: 'Package (PAK) Claims',
                link: `${commercialConstants.URLS.pakClaimsList}`
            }, {
                name: 'Claim Overview',
                link: `${commercialConstants.URLS.claimOverview}`
            }
        ];
        this.commercialLoggingService.logPageLoad(this.LOGGER, this.currentPage, this.getLogMetadata());
        this.getClaimInfo();
        this.getEvents();
        this.commercialLoggingService.updatePreviousUrlContext();
    }

    private getLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: this.claimsDataService.getClaimsPolicyNumber(),
            policyType: this.claimsDataService.getClaimsPolicyType(),
            lineOfBusiness: this.claimsDataService.getFnolFlow(),
            claimsDisplayCount: this.claimEventsFiltered.length || 'UNKNOWN',
            alphaState: this.claimsDataService.getPrimary(this.claimsDataService.getClaimsPackage()?.address)?.state || 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            claimNumber: this.claimInfo?.claimNumber || '',
            ...additionalFields
        };
    }
}
